import { useCallback } from 'react';

import {
  useMyStore,
  useProductEntryDataLayerValues
} from '../../../../shared/hooks/hooks';

import { getPdlDataLayerValues } from '../../../../shared/utils/product/product';
import { getPdpMultiStoreDataLayerValues } from '../../utils/product-details-page-analytics-utils';

import {
  PAGE_CATEGORY,
  PAGE_NAME,
  PAGE_SECTION_NAME,
  PAGE_SUBCATEGORY,
  PAGE_TYPE,
  PDL_CURRENT_RECOMMENDATION_RANK,
  PDL_DRY_RECOMMENDATION_RANK,
  PDL_WET_RECOMMENDATION_RANK,
  PRODUCT_BRAND
} from '../../../../shared/constants/data-layer';

function usePDPAnalytics() {
  const { getProductEntryDataLayerValues } = useProductEntryDataLayerValues();
  const { myStore } = useMyStore();
  const myStoreCode = myStore?.code;
  const getPdpDataLayer = useCallback(
    ({
      isNoLongerAvailable,
      isPrebuilt,
      product,
      selectedStoreCode = myStoreCode,
      treadwellPreferences,
      weatherDetails
    }) => {
      const productType = isPrebuilt
        ? 'prebuilt'
        : product?.productType?.toLowerCase();
      const productValues = getProductEntryDataLayerValues(product);
      const recommendationData = product?.recommendationData;
      const dataLayer = {
        [PAGE_CATEGORY]: `${productType}_detail`,
        [PAGE_NAME]: isNoLongerAvailable
          ? 'seo_product_no_longer_available'
          : `${productType}_detail`,
        [PAGE_SECTION_NAME]: document.title,
        [PAGE_SUBCATEGORY]: `${productType}_detail_${productValues[PRODUCT_BRAND][0]}`,
        [PAGE_TYPE]: 'product_detail',
        ...productValues,
        ...getPdpMultiStoreDataLayerValues(
          product,
          myStore?.nearByStores,
          myStoreCode,
          selectedStoreCode
        )
      };

      if (recommendationData && treadwellPreferences) {
        Object.assign(
          dataLayer,
          getPdlDataLayerValues(product, treadwellPreferences, weatherDetails)
        );
        dataLayer[PDL_CURRENT_RECOMMENDATION_RANK] =
          product?.recommendationData?.rank;
        dataLayer[PDL_DRY_RECOMMENDATION_RANK] =
          product?.recommendedDistanceData?.dryDistanceProduct?.recommendationData?.rank;
        dataLayer[PDL_WET_RECOMMENDATION_RANK] =
          product?.recommendedDistanceData?.wetDistanceProduct?.recommendationData?.rank;
      }

      return dataLayer;
    },
    [getProductEntryDataLayerValues, myStore?.nearByStores, myStoreCode]
  );

  return { getPdpDataLayer };
}

export default usePDPAnalytics;
